import * as React from "react";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CyPortfolioDetailsSortable from "../../../components/Charts/CyPortfolioDetailsSortable";
import CurrencyNumber from "../../../components/UI/CurrencyNumber";

const StrategyPerformanceStats = (props) => {
  const {
    portfolio,
    baseChartData,
    annualWithdrawalChartData,
    totalWithdrawal,
    bdIsCambridge,
    accessLevel,
  } = props;
  const { cprRecommendation, metadata } = portfolio;

  const useWbiSingleStrategy =
    ['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(metadata.managerType);
  const managerList = cprRecommendation.managers;
  const startDate = moment(baseChartData[0].date)
    .startOf("month")
    .subtract(2, "months");

  return (
    <section
      className={"content"}
      data-toc={
        useWbiSingleStrategy
          ? `Selected Portfolio`
          : `Cy Optimized Portfolio`
      }
    >
      <Grid container={true}>
        <Grid item={true} xs={12}>
          <Typography variant="h4">
            {useWbiSingleStrategy
              ? `Selected Portfolio`
              : `Cy Optimized Portfolio`}
          </Typography>
          <Typography variant="h5" gutterBottom={true}>
            Hypothetical Illustration
          </Typography>
          <Typography variant="h6" gutterBottom={true}>
            Investment Amount{" "}
            <CurrencyNumber value={metadata.initialInvestment} />
          </Typography>
        </Grid>
        <Grid item={true} xs={12}>
          {useWbiSingleStrategy ? (
            <Typography variant="h5">
              {cprRecommendation.displayName
                ? `(${cprRecommendation.displayName})`
                : ""}
            </Typography>
          ) : (
            <Typography variant="h5">
              Cy Optimized Portfolio:{" "}
              {cprRecommendation.displayName
                ? `(${cprRecommendation.displayName})`
                : ""}
            </Typography>
          )}
          <CyPortfolioDetailsSortable
            strategyStartDate={startDate}
            managerList={managerList}
            portfolioSummary={cprRecommendation.summary}
            finalWealth={baseChartData.slice(-1)[0]}
            finalWealthWithAnnualWithdrawal={
              annualWithdrawalChartData
                ? annualWithdrawalChartData.slice(-1)[0]
                : null
            }
            riskPeriod={metadata.riskPeriod}
            totalWithdrawal={totalWithdrawal}
            bdIsCambridge={bdIsCambridge}
            accessLevel={accessLevel}
            forPrinting={true}
          />
        </Grid>
      </Grid>
    </section>
  );
};

export default StrategyPerformanceStats;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/StrategyPerformanceStats.jsx